import React from 'react';
import PageBanner from 'components/banners/PageBanner';
import Features from 'components/Features';
import { Col, Container, Row, Image } from 'react-bootstrap';
import styles from './addons.module.scss';
import computer from 'assets/images/cap60-home-2.jpeg';
import { Helmet } from 'react-helmet';
import RequestDemoButton from 'components/RequestDemoButton';
const FEATURE_DATA = [
  {
    id: 'ROMA reporting',
    title: 'Provides aggregated statewide ROMA reporting.',
  },
  {
    id: 'Collect on Organizational Performance Standards',
    title: 'Agencies can report on standards met and progress to those unmet.',
  },
  {
    id: 'Demographic data',
    title: 'Provides aggregated demographic data',
  },
];
function StateKiosk() {
  return (
    <div>
      <Helmet>
        <title>State Kiosk - CAP60</title>
        <meta
          name="description"
          content="Cap60s' state kiosk provides aggregated statewide ROMA reporting, aggregated demographic data, collects and organizational standards. "
        />
        <meta name="keyword" content="state kiosk" />
      </Helmet>
      <PageBanner
        title="CAP60’s State Kiosk"
        subtitle="The State Kiosk provides and online portal which aggregates CSBG reporting
        data from sub-grantees."
      />
      <ClienDesk />
      <div className="floralbg-blue">
        <Container className="overflow-auto">
          <Features
            data={FEATURE_DATA}
            variant="secondary"
            title="Features"
            itemsPerRow={4}
            itemClass={styles.featureItem}
          />
        </Container>
      </div>
    </div>
  );
}

function ClienDesk() {
  return (
    <div className={styles.clientDeskWrapper}>
      <Container>
        <Row>
          <Col md="7">
            <div className="heading">
              <h2>How does it work?</h2>
            </div>
            <p>
              The kiosk pulls numbers from each state database and displays a
              total aggregated amount of data for various CSBG sections. This
              includes aggregated numbers for demographic data, services, and
              outcome information. The State Kiosk also allows the option to
              drilldown on the reported numbers to showcase exactly which
              databases contributed to what portion of the total amount. It can
              also drilldown further to display details (names, birthdates,
              etc.) of each client being reported.
            </p>
            <p>
              When a CSBG report is created through the State Kiosk, it also
              creates a report in each agency database, which cannot be altered
              by agency staff. This ensures that the reporting parameters,
              dates, and reporting options all align with what the state needs
              at the time and maintains the integrity of the data. With the
              kiosk, staff is given the option to select the databases on which
              they want to report. They can get an aggregated total for all
              databases or fewer databases.
            </p>
            <p>
              <b>How the Kiosk Meets Organizational Standards </b> <br />{' '}
              Another portion of the kiosk ties to Organizational Performance
              Standards, where the staff is able to see which agency has
              uploaded documentation in support of meeting these standards. The
              State Kiosk will showcase which standards have been met, or not
              met, and will also showcase any notes documented by agency staff.
              This functionality of the kiosk takes away from having to log in
              to each agency database individually to determine whether
              standards have been met and if documentation has been uploaded.
            </p>
            <RequestDemoButton />
          </Col>
          <Col md="5">
            <div className={styles.rightDark}>
              <Image src={computer} />
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default StateKiosk;
